/**
 * @func validListProp
 * @param {array} list - array of objects to be checked.
 * @param {string} prop - the key to check for in each item in the array
 * @return {boolean}
 * @desc Checks that the prop key exists for each item in the array.
 * ```js
 * const myList = [{name: 'Tory'}, {name: 'Alexandra'}]
 * validListProp(myList, 'name');
 * // returns true
 * ```
 * NOTE: TypeScript makes this function unnecessary.
 * For now it serves two purposes:
 * 1) In JS client code, it handles type errors.
 * 2) In TS code in warbler or elsewhere, it forces strict typing with `prop: keyof T`
 * @memberof module:Array
 * @instance
 */
function validListProp(list, prop) {
    if (typeof prop !== 'string') {
        console.warn(`warbler: key ${String(prop)} is not a string`); // eslint-disable-line
        return false;
    }
    if (!list.every(object => Object.keys(object || {}).includes(prop))) {
        console.warn(`warbler: key ${prop} not found in every list item`); // eslint-disable-line
        return false;
    }
    else {
        return true;
    }
}

export { validListProp as default };
